import { lazy } from 'react';

const loadProposalCreatePage = () => import('./ProposalCreatePage');
export const ProposalCreatePageLoad = lazy(loadProposalCreatePage);

const loadProposalNewCreatePage = () => import('./ProposalNewCreatePage');
export const ProposalNewCreatePage = lazy(loadProposalNewCreatePage);

const loadProposalCreateFormPage = () => import('./ProposalCreateFormPage');
export const ProposalCreateFormPage = lazy(loadProposalCreateFormPage);

const loadProposalEditFormPage = () => import('./ProposalEditFormPage');
export const ProposalEditFormPage = lazy(loadProposalEditFormPage);

const loadProposalWrapperPage = () => import('./ProposalWrapperPage');
export const ProposalWrapperPageLoad = lazy(loadProposalWrapperPage);

const loadProcedureCreateFormPage = () => import('./ProcedureCreateFormPage');
export const ProcedureCreateFormPage = lazy(loadProcedureCreateFormPage);

const loadProcedureDetailsPage = () => import('./ProcedureDetailsPage');
export const ProcedureDetailsPage = lazy(loadProcedureDetailsPage);

const loadCMSPage = () => import('./CMSPage');
export const CMSPageLoad = lazy(loadCMSPage);

const loadFaqsPage = () => import('./FaqsPage');
export const FaqsPageLoad = lazy(loadFaqsPage);

const loadReportPage = () => import('./ReportPage');
export const ReportPageLoad = lazy(loadReportPage);
